export class EidosBaseList {
  id:string;
  code: string;
  description: string;

  constructor() {
    this.id = '';
    this.code='';
    this.description='';
  }
}

export interface IEidosBaseList {
  id:number,
  code:string,
  description:string
}
